import { render, staticRenderFns } from "./readingtwo.vue?vue&type=template&id=1297876c&scoped=true"
import script from "./readingtwo.vue?vue&type=script&lang=js"
export * from "./readingtwo.vue?vue&type=script&lang=js"
import style0 from "./readingtwo.vue?vue&type=style&index=0&id=1297876c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1297876c",
  null
  
)

export default component.exports